import Rules from "../rules.js";
import Utils from "../utils.js";

class PresEndPage {
  constructor() {}
  setup() {
    window.PageHeader = (country, hasResidency, higherEducation) => (
      `
      <div class="vrtx-introduction show-introduction">
        ${i18n.admissionIntro}
      </div>

      ${Header(i18n.titleParameters)}
      ${ParametersHeader(country, hasResidency, higherEducation)}
      `
    )

    window.Page = (group, country, hasResidency, higherEducation, lang) => (
      `
      ${FactBox(Rules.showSpecialPriceRule(group, country), country, hasResidency)}
      ${Requirements(group, country, higherEducation, lang)}
      ${Documentation(hasResidency, group, country, higherEducation, lang)}

      <p class="vrtx-date-info">&nbsp;</p>
      <p id="admission-buttons">
        ${Button("mailto:?subject=" + encodeURIComponent($("h1").text()) + "&body=" + i18n.mailBodyPre + encodeURIComponent(location.href) + i18n.mailBodyPost, i18n.btnSendEmail)}
      </p>

      ${Apply(group, country, higherEducation, lang)}
      `
    )

    window.CutOff = function(lang) {
      var html = "";
      var text = Fellestekst("studiet-master-cutoff", "studiet-master-cutoff-SFMASTER", lang, true);
      if(text) html += '<div class="admission-box admission-facts">' + text + '</div>';
      return html;
    }

    window.ParametersHeader = function(country, hasResidency, higherEducation) {
      var htmlParameters = "";

      if(country != null && country != "") {
        htmlParameters += "<li>" + Label(i18n.citizenship, App.countries[country]);
      }
      if(higherEducation.length) {
        var allHigherEducations = "";
        for(var i = 0, len = higherEducation.length; i < len; i++) {
          if(i > 0 && i < len - 1)   allHigherEducations += ", ";
          if(i > 0 && i === len - 1) allHigherEducations += " " + i18n.and + " ";

          allHigherEducations += App.countries[higherEducation[i]];
        }
        htmlParameters += (htmlParameters != "" ? "</li><li>" : "<li>") + Label(i18n.higherEducation, allHigherEducations);
      }
      if(hasResidency != null && country != "no") {
        htmlParameters += (htmlParameters != "" ? "</li><li>" : "<li>") + Label(i18n.residency, (hasResidency ? i18n.yes : i18n.no));
      }
      htmlParameters = (htmlParameters != "" ? "<ul>" + htmlParameters + "</li></ul>" : "");

      return htmlParameters;
    }

    window.debug = function(group, country, hasResidency, higherEducation) {
      return "";

      var html = "<div class='admission-box admission-debug'>";
      html += "<h2>Debug</h2>";
      html += ParagraphLabelLine("Kategori utifra brukersvar", group);
      html += ParagraphLabelLine("Programkode", App.program.programCode);
      html += ParagraphLabelLine("Program erfaringsbasert?", App.program.experienceBased ? "Ja" : "Nei");

      html += ParagraphLabelLine("Fellestekst plassering", App.pathFellestekst);
      for(var id in App.program.fellestekst) {
        if(App.program.fellestekst[id]) {
          html += ParagraphLabelLine("Program valgt fellestekst", id + ".html ==> ID:" + App.program.fellestekst[id]);
        }
      }

      html += "</div>";

      return html;
    }
  }
}
export default new PresEndPage;
